import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Pagination from 'react-bootstrap/Pagination';

const worksData = [
  {
    id: 1,
    link: '/jornadacientifica',
    image: require('../assets/Not_01.jpg'),
    title: 'Da Teoria à Prática',
    subtitle: ' Transformando Conhecimento em Ação. Uma jornada de descobertas, trocas e experiências que aproximam a ciência do cotidiano, desafiando fronteiras e criando novas possibilidades para o futuro.'
  },
  {
    id: 2,
    link: '#',
    image: require('../assets/Not_02.jpg'),
    title: 'Formação de Qualidade para um Futuro Brilhante',
    subtitle: 'Prepare-se para os desafios do mercado de trabalho com a melhor educação. Aqui, você encontra o suporte, o conhecimento e as ferramentas necessárias para alcançar grandes conquistas. Dê o primeiro passo agora e construa um futuro de sucesso.'
  },
  {
    id: 3,
    link: '#',
    image: require('../assets/Not_03.jpg'),
    title: 'O Seu Futuro Profissional Merece o Melhor',
    subtitle: 'Com a formação certa, você está a um passo de transformar seus sonhos em realidade. Invista em você, aprenda com os melhores e prepare-se para um futuro de sucesso. Estamos aqui para te ajudar a alcançar o topo.'
  },
  {
    id: 4,
    link: '#',
    image: require('../assets/Not_05.jpg'),
    title: 'Palestra  sobre a violencia Domestica',
    subtitle: 'Na palestra sobre a violência doméstica, realizada em uma data não especificada, especialistas e ativistas se reuniram para discutir esse tema crucial.'
  },
  {
    id: 5,
    link: '#',
    image: require('../assets/Not_06.jpg'),
    title: 'Lançamento da ROC- Revista Olhar Científico',
    subtitle: 'No lançamento da ROC - Revista Olhar Científico, um evento marcante ocorrido em uma data específica não fornecida, a comunidade acadêmica se reuniu para celebrar a inauguração desta importante plataforma de divulgação científica. '
  },
  {
    id: 6,
    link: '#',
    image: require('../assets/Not_08.jpg'),
    title: 'Batismo dos Caloiros ISPA 2023',
    subtitle: 'No Batismo dos Caloiros do ISPA em 2023, os novos estudantes foram recebidos em uma atmosfera de camaradagem e tradição. '
  },
  {
    id: 7,
    link: '#',
    image: require('../assets/Not_10.jpg'),
    title: 'Inaguraçao do tribunal simulado do  ISPA dia 17 de Dezembro I2023',
    subtitle: 'Na inauguração do Tribunal Simulado do ISPA em 17 de dezembro de 2023, estudantes e professores se reuniram para celebrar a abertura desta nova iniciativa educacional.'
  },
  {
    id: 8,
    link: '#',
    image: require('../assets/Not_12.jpg'),
    title: 'Campeonato Dispostivo',
    subtitle: 'No Campeonato Esportivo do ISPA, realizado em uma data não especificada, atletas e entusiastas do esporte se reuniram para competir e celebrar a paixão pelo jogo. O evento contou com uma variedade de modalidades esportivas, incluindo futebol, basquete, vôlei e muito mais.'
  },
  {
    id: 9,
    link: '#',
    image: require("../assets/Not_11.jpg"),
    title: 'Entrega de medalhas',
    subtitle: 'Na cerimônia de entrega de medalhas do ISPA, realizada em uma ocasião especial, atletas e participantes foram reconhecidos por suas conquistas e dedicação. Em um ambiente festivo e inspirador, os vencedores de diferentes competições esportivas foram chamados ao palco para receber suas merecidas medalhas.'
  }
]

let active = 2;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}
function AppWorks() {
  return (
    <section id="works" className="block works-block">
      <Container fluid>
        <div className="title-holder">
          <h2>Notícia</h2>
          <div className="subtitle">Actividades Curriculares</div>
        </div>
        <Row className='portfoliolist'>
          {
            worksData.map(works => {
              return (
                <Col sm={4} key={works.id}>
                  <div className='portfolio-wrapper'>
                    <a href={works.link}>
                      <Image src={works.image} />
                      <div style={{paddingTop:'80px'}} className='label text-center'>
                        <h3>{works.title}</h3>
                        <p style={{color:'#FFFFFF'}}>{works.subtitle}</p>
                      </div>
                    </a>
                  </div>
                </Col>
              );
            })
          }
        </Row>
      </Container>  
    </section>
  );
}
export default AppWorks;